import "./sprinkles.css.ts.vanilla.css-mistica.js";
import "./touchable.css.ts.vanilla.css-mistica.js";
var a = "mhti6u2 _1y2v1nfk8", f = "mhti6u0", y = "mhti6u5", _ = "mhti6u2 _1y2v1nfk8 _1y2v1nf71 _1y2v1nf8a _1y2v1nf9j _1y2v1nfas _1y2v1nfha _1y2v1nfjq _1y2v1nfhv _1y2v1nf3h _1y2v1nf70 _1y2v1nfka";
export { a as base, f as marginReset, y as notTouchable, _ as touchable };
